import { lastValueFrom } from 'rxjs';
import { ThemeState } from '@shared/states/theme.state';

export function initTheme(themeState: ThemeState) {
  return (): Promise<void> => {
    return lastValueFrom(themeState.init());
  };
}
